import React from 'react';

import { FolderMinusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { confirmDetachCardFromListPoint3 } from './confirm-detach-card-from-list/confirmDetachCardFromList.point3';
import type { DetachCardsFromListPropsPoint3 } from './types.point3';
import { useCardListLinkerPoint3 } from '@vlabs/api/useCardListLinker.point3';

interface DetachCardsFromListButtonProps extends
  DetachCardsFromListPropsPoint3,
  ButtonProps {}

const displayName = 'DetachCardsFromListButton';
const testid = buildTestid(displayName);

export function DetachCardsFromListButtonPoint3({
  cardIds,
  fromListId,
  onDetachCardsFromList = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachCardsFromListButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const detachCards = useCardListLinkerPoint3(({
    action: 'detach', cardIds, listId: fromListId, onSuccess: onDetachCardsFromList,
  }));

  const onClickHandler = () => {
    confirmDetachCardFromListPoint3({
      listId: fromListId,
      onConfirm: detachCards,
    });
  };

  return (
    <Button
      icon={<FolderMinusIcon />}
      onClick={onClickHandler}
      variant="flat"
      {...testid(dataTestId, fromListId)}
      {...props}
    >
      {t('features:detachCardsFromList.detach')}
    </Button>
  );
}
